<template>
  <v-list-item class="white rounded-lg">
    <v-list-item-content>
      <v-list-item-title class="font-weight-bold subtitle-2">{{
        produtor.nome
      }}</v-list-item-title>
      <v-list-item-subtitle class="mt-1">
        <v-icon x-small>mdi-pound</v-icon> {{ produtor.matr }} <br />
        <v-icon x-small>mdi-map-marker-outline</v-icon>
        {{ produtor.cidade }} -
        {{ produtor.uf }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu
        v-model="menu"
        offset-y
        left
        :close-on-content-click="false"
        rounded="lg"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="green"
            title="Adicionar visita"
            v-on="on"
            v-bind="attrs"
            ><v-icon>mdi-account-plus-outline</v-icon></v-btn
          >
        </template>
        <v-card max-width="300" min-width="300" outlined rounded="lg">
          <v-card-title class="subtitle-1 font-weight-bold grey lighten-3"
            >Nova visita</v-card-title
          >
          <v-card-text class="pt-5 body-1">
            <v-form ref="formNovaVisita">
              <v-text-field
                label="Data da visita"
                type="date"
                v-model="data_visita_form"
                outlined
                :rules="[validarIntervaloData]"
              ></v-text-field>
            </v-form>
            Deseja iniciar a visita para o cooperado
            <span class="font-weight-medium"
              >{{ produtor.nome }} (#{{ produtor.matr }})</span
            >?
          </v-card-text>
          <v-card-actions class="mt-2 mb-2">
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="success"
              @click="iniciarVisita()"
              :loading="criandoVisita"
              >Iniciar visita <v-icon left>mdi-chevron-double-right</v-icon>
            </v-btn>
            <v-btn text @click="menu = false" :disabled="criandoVisita"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  props: {
    produtor: { type: Object },
  },
  watch: {
    menu: function (open) {
      if (open) {
        this.data_visita_form = moment().format("YYYY-MM-DD");
      }
    },
  },
  computed: {
    ...mapState("visitaTecnica", ["visita", "configuracoes"]),
  },
  data: () => ({
    menu: false,
    data_visita_form: moment().format("YYYY-MM-DD"),
    criandoVisita: false,
  }),
  methods: {
    ...mapActions("visitaTecnica", ["criarVisita"]),
    validarIntervaloData(value) {
      if (!value) return true; // deixa vazio passar, outra regra pode validar required

      const dataMin = this.configuracoes.dados.min_data_visita;
      const dataMax = this.configuracoes.dados.max_data_visita;

      if (value < dataMin) {
        return `A data mínima permitida é ${this.formatarData(dataMin)}`;
      }
      if (value > dataMax) {
        return `A data máxima permitida é ${this.formatarData(dataMax)}`;
      }
      return true; // válido
    },
    formatarData(date) {
      const d = new Date(date);
      return d.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    },
    async iniciarVisita() {
      if (this.$refs.formNovaVisita.validate()) {
        this.visita.data_visita = this.data_visita_form;
        this.visita.matricula = this.produtor.matr;

        this.criandoVisita = true;
        var ret = await this.criarVisita();
        this.criandoVisita = false;

        if (ret) {         
          this.$router.replace({ path: `/visita-tecnica/${this.visita.id}` });
        }
      }
    },
  },
};
</script>

<style>
</style>